@import ../../styles/helpers

.container
    padding: 30px 5px
.section_picture
    display: flex

    img
        width: 150px
        height: 150px
        border-radius: 50%
        +m
            width: 100px
            height: 100px
    .namebox
        padding: 20px
        .name
            font-size: 30px
            font-weight: bold
        .username
            font-size: 15px
            margin-bottom: 20px
.iconbox
    border: 1px solid #2A323D!important
    height: 55px
    border-radius: 30%!important
    background-color: #11141B!important
    +m
        min-width: 40px!important
        height: 45px
    &:hover
        border: 1px solid #7d7f81!important
    svg
        fill: $white
        +m
            width: 20px
            height: 20px

.gray_box
    border-radius: 20px
    background-color: #1B2028
    padding: 20px

.section_friends
    .avatar_group
        margin-top: 20px
        display: flex
        .avatar
            width: 40px
            img
                width: 50px
                height: 50px
                border-radius: 100px
        .addicon
            margin-top: 10px
            margin-left: 20px
.accordion
    padding-top: 30px
    padding-bottom: 1px
    .accordion_item
        margin-bottom: 30px

.text_small
    font-size: 12px

.text_mute
    color: #8d8b8b

.activities
    font-size: 11px
    img
        width: 40px
        height: 40px
        border-radius: 100px

.game_header
    padding: 50px 0px

.game
    img
        width: 100%
        height: 100%
        border-radius: 20px
        cursor: pointer
